// src/components/About.jsx
import React from 'react';

const teamMembers = [
  {
    name: 'Ashif Panakkat, P.E.',
    image: '/assets/about/ashif.jpg',
    description:
      'Ashif is partner at Rubix, and a professional engineer registered in 20 states and DC. He has over 20 years of experience leading design on commercial, institutional, and industrial projects. Ashif has a Master’s degree from the Ohio State University.',
    linkedin: 'https://www.linkedin.com/in/ashif-panakkat/',
  },
  {
    name: 'Minu Bhadran, MTech.',
    image: '/assets/about/minu.jpeg',
    description:
      'Minu joined Rubix in 2013 and  manages high volume client accounts, including for McDonalds, Chipotle, and TJ Max. Prior to Rubix, she worked as. a junior engineer at Atkins – one of the world’s leading engineering firms. Minu has a Masters degree from the Indian Institute of Technology.',
    linkedin: 'https://www.linkedin.com/in/minu/',
  },
  {
    name: 'Greg Riley, P.E., P.Eng.',
    image: '/assets/about/greg.jpeg',
    description:
      'Greg consults with Rubix on select projects. He has over 20 years of experience and is a registered professional and structural engineer in 49 states, DC, and seven  Canadian provinces. Greg’s competence spans structural design and inspections.',
    linkedin: 'https://www.linkedin.com/in/greg/',
  },
];

const About = () => (
  <section id="about" className="py-16" style={{ backgroundColor: '#FFFFFF' }}>
    <div className="container mx-auto text-center">
      {/* Main Heading */}
      <h2
        className="text-4xl font-bold mb-8"
        style={{
          fontFamily: 'Montserrat, sans-serif',
          fontSize: '56px',
          fontWeight: '200',
          color: '#242528',
          textAlign: 'center',
        }}
      >
        About Rubix
      </h2>

      {/* Subheading */}
      <p
        className="text-xl mb-8"
        style={{
          fontFamily: 'Montserrat, sans-serif',
          fontSize: '20px',
          fontWeight: '200',
          color: '#555',
        }}
      >
        Rubix was founded in 2011 by engineers who believed in solving problems for clients.
      </p>

      {/* Team Members Section */}
      {teamMembers.map((member, index) => (
        <div
          key={index}
          className={`flex flex-col md:flex-row items-center mb-16 ${
            index % 2 === 1 ? 'md:flex-row-reverse' : ''
          }`}
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            border: '1px solid #e5e5e5',
            padding: '20px',
            borderRadius: '8px',
          }}
        >
          {/* Image Column */}
          <div
            className="md:w-1/2"
            style={{
              padding: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              src={member.image}
              alt={member.name}
              className="object-cover rounded-lg"
              style={{
                width: '90%',
                height: 'auto',
                maxWidth: '400px',
                maxHeight: '450px',
              }}
            />
          </div>

          {/* Text Column */}
          <div
            className="md:w-1/2 flex items-center justify-center"
            style={{
              padding: '20px',
              textAlign: 'center',
            }}
          >
            <div>
              <h3
                className="text-2xl font-semibold mb-4 pb-10 "
                style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '30px',
                  fontWeight: '500',
                  color: '#333',
                  
                }}
              >
                {member.name}
              </h3>
              <p
                className="text-md mb-4"
                style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '16px',
                  fontWeight: '100',
                  color: '#555',
                }}
              >
                {member.description}
              </p>
              <a
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-block',
                  textDecoration: 'none',
                  color: '#0A66C2',
                }}
              >
                {/* SVG File Path */}
                <img
                  src="/assets/about/linkedin.svg"
                  alt="LinkedIn"
                  style={{
                    width: '38px',
                    height: '38px',
                    verticalAlign: 'middle',
                  }}
                />
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default About;
